import { ConfirmCardPaymentData } from '@stripe/stripe-js';
import { StripeInstance } from 'ngx-stripe';

import { IPaymentIntentDtoOut } from './../../interfaces/stripe.interface';

export class CreatePaymentIntent {
    public static readonly type = '[Stripe] create payment intent';
    constructor(public paymentIntentPayload: IPaymentIntentDtoOut) {}
}

export class ConfirmPayment {
    public static readonly type = '[Stripe] confirm payment';
    constructor(public stripe: StripeInstance, public data: ConfirmCardPaymentData) {}
}

export class ResetErrorStripe {
    public static readonly type = '[Stripe] reset error';
}

export class ResetStripeState {
    public static readonly type = '[Stripe] reset state';
}
